module.exports = __webpack_public_path__ + "img/ico-pages.655de29a.svg";